import { Job } from "models/Job";

export const jobsDictionaryToArray = (jobs: { [x: string]: Job }): Job[] => {
  return Object.entries(jobs).map(([id, job]) => job);
};
